var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCadastrarLinhaCuidado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99854 22.0046L9.99937 20.0038L7.99854 18.0029",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99683 20.0031H9.99933",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94337 16.0021C2.23681 12.5672 2.89462 8.42809 5.58202 5.69147C8.26943 2.95484 12.3959 2.22202 15.8612 3.86597C19.3266 5.50991 21.3694 9.1694 20.9499 12.9819C20.5304 16.7944 17.7409 19.9222 14.001 20.7734",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7517 11.2503C15.7517 10.8359 15.4157 10.5 15.0013 10.5H13.5007V8.99934C13.5007 8.58495 13.1648 8.24902 12.7504 8.24902H11.2498C10.8354 8.24902 10.4995 8.58495 10.4995 8.99934V10.5H8.99885C8.58446 10.5 8.24854 10.8359 8.24854 11.2503V12.7509C8.24854 13.1653 8.58446 13.5012 8.99885 13.5012H10.4995V15.0018C10.4995 15.4162 10.8354 15.7521 11.2498 15.7521H12.7504C13.1648 15.7521 13.5007 15.4162 13.5007 15.0018V13.5012H15.0013C15.4157 13.5012 15.7517 13.1653 15.7517 12.7509V11.2503Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastrarLinhaCuidado);
export default __webpack_public_path__ + "static/media/cadastrarLinhaCuidado.d6e64afb88ac560f81fa084ab1b1dd89.svg";
export { ForwardRef as ReactComponent };